module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_09-54f8a76a91845ac5de7269119a5cf6f8.svg";